<template>
  <div class="similar-scroller-wrap">
    <button
      type="button"
      class="similar-scroller-arrow similar-scroller-arrow--left"
      :class="{ 'is-hidden': !canLeft }"
      :disabled="!canLeft"
      aria-label="Előző"
      @click="page(-1)"
    >
      <i class="fas fa-chevron-left"></i>
    </button>

    <div ref="track" class="similar-scroller" @scroll="updateArrows">
      <slot>
        <model-card
          v-for="item in sortedModels"
          :key="item.make.name + item.MODNameGrp1 + item.body_type + item.MODBegin"
          :model="item"
          page="similar"
        />
      </slot>
    </div>

    <button
      type="button"
      class="similar-scroller-arrow similar-scroller-arrow--right"
      :class="{ 'is-hidden': !canRight }"
      :disabled="!canRight"
      aria-label="Következő"
      @click="page(1)"
    >
      <i class="fas fa-chevron-right"></i>
    </button>
  </div>
</template>

<script>
import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component, Prop } from 'vue-property-decorator';
import { calculateModelPrice } from '../services/modelPrice';

const priceSearchModule = namespace('price_search');

@Component
export default class SimilarModelsScroller extends Vue {
  @Prop(Array) models;

  @priceSearchModule.Getter('getContractLength') contractLength;
  @priceSearchModule.Getter('getAnnualMileage') annualMileage;
  @priceSearchModule.Getter('getPrinp2') prinp2;
  @priceSearchModule.Getter('getInitialPaymentPercent') initialPaymentPercent;

  canLeft = false;
  canRight = false;

  get sortedModels() {
    // The server can only order by a fixed column, but the card prints a price that reacts to the
    // header price menu — so sort by the same number we render, or the list reads as unsorted.
    // Cars with no price for the chosen combination sink to the end instead of leading at 0.
    const models = this.models || [];

    return models.slice().sort((a, b) => {
      const pa = calculateModelPrice(a, {
        contractLength: this.contractLength,
        annualMileage: this.annualMileage,
        initialPaymentPercent: this.initialPaymentPercent,
        prinp2: this.prinp2,
      });
      const pb = calculateModelPrice(b, {
        contractLength: this.contractLength,
        annualMileage: this.annualMileage,
        initialPaymentPercent: this.initialPaymentPercent,
        prinp2: this.prinp2,
      });
      const va = (pa === null || pa === '') ? Number.MAX_VALUE : pa;
      const vb = (pb === null || pb === '') ? Number.MAX_VALUE : pb;

      return va - vb;
    });
  }

  mounted() {
    this.$nextTick(this.updateArrows);
    window.addEventListener('resize', this.updateArrows);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.updateArrows);
  }

  page(dir) {
    const t = this.$refs.track;
    if (!t) return;
    t.scrollBy({ left: dir * t.clientWidth, behavior: 'smooth' });
  }

  updateArrows() {
    const t = this.$refs.track;
    if (!t) return;
    this.canLeft = t.scrollLeft > 1;
    this.canRight = t.scrollLeft + t.clientWidth < t.scrollWidth - 1;
  }
}
</script>

<style scoped>
.similar-scroller-wrap {
  display: flex;
  align-items: center;
}

.similar-scroller {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 16px;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  scrollbar-width: none;
}
.similar-scroller::-webkit-scrollbar { display: none; }

/* each model-card root is the .col-* div — force a fixed card width and no shrink */
.similar-scroller > .col-12,
.similar-scroller > div[class*="col-"] {
  flex: 0 0 auto !important;
  width: 270px !important;
  max-width: 270px !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  scroll-snap-align: start;
}

.similar-scroller-arrow {
  flex: 0 0 28px;
  background: none;
  border: none;
  padding: 0;
  color: #9aa3ab;
  font-size: 1.5rem;
  line-height: 1;
  cursor: pointer;
}
.similar-scroller-arrow.is-hidden { visibility: hidden; }
</style>
